
import Vue from 'vue'
import { VCard, VCardText, VTab, VTabItem, VTabs } from 'vuetify/lib'
import JcdcBadge from '@/components/jcdc/JcdcBadge.vue'

export default Vue.extend({
  name: 'JcdcTabs',
  components: {
    VTabs,
    VTab,
    VTabItem,
    VCard,
    VCardText,
    JcdcBadge,
  },
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
    fill: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: Number || String,
      default: null,
    },
    disabledTabs: {
      type: Array as () => Array<number>,
      default: (): [] => [],
    },
    notedTabs: {
      type: Array as () => Array<number>,
      default: (): [] => [],
    },
    items: {
      type: Array as () => Array<string>,
      default: (): [] => [],
    },
  },
  data() {
    return {
      tab: this.activeTab,
    }
  },
  methods: {
    disabledTab(index) {
      return this.disabledTabs.includes(index)
    },
    notedTab(index) {
      return this.notedTabs.includes(index)
    },
  },
})
